import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

import { useAuth } from '../context/auth_context_provider';

export const ProtectedRoute: React.FC = () => {
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
};